<template>
  <div>
    <h1 class="mdn-Heading mdn-Heading--xl">Menu X Perfil</h1>
    
     <div class="mb-3 mt-5">
        <SGPFormSelectComponent 
            :name="'acl_perfil_id'"
            :listaDeOptions="listaDePerfis"
            v-model="acl_perfil_id"
            :optionLabel="'name'"
            :placeholder="'Perfil'"
            :error="validationErrors.first('acl_perfil_id')"
            data-vv-as="Perfil"
            @change="filtrarMenusPorPerfis($event)"
          />
      </div>
    <SGPTabelaComponent
      v-if="listaMenusPorPerfis.length"
      :colunas="colunas"
      :dados="listaMenusPorPerfis"
      :usuarioPodeExcluir="false"
      :usuarioPodeEditar="false"
      :somenteLeitura="true"
    ></SGPTabelaComponent>

    <SGPAlertaComponent v-else />

    <SGPLoadingComponent v-if="loadingPerfisMenus" />
  </div>
  
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  name: "ListagemMenuXPerfilComponent",

  data () {
    return {
      acl_perfil_id: ''
    }
  },

  created () {
    this.listarPerfis();
    // this.listarMenusPorPerfis(0);
  },

  computed: {
    ...mapGetters('perfisMenus', ['listaMenusPorPerfis','loadingPerfisMenus']),
    ...mapGetters('perfis', ['listaDePerfis']),

    colunas () {
      return [ 
        {
          key: 'menu',
          label: 'Título Menu',
          sortable: false
        },
        {
          key: 'route_name',
          label: 'Rota',
          sortable: false
        },
      ]
    }
  },

  methods: {
    ...mapActions('perfisMenus', [
      'listarMenusPorPerfis'
    ]),

    ...mapActions('perfis', [
      'listarPerfis'
    ]),

    filtrarMenusPorPerfis(event) {
      if(typeof event == 'undefined'){
        return false;
      }

      let aclPerfilId = (this.acl_perfil_id != '') ? this.acl_perfil_id : 0; 

      this.listarMenusPorPerfis(aclPerfilId);
    }

  }
};
</script>
